import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2023 TFH Prow. All rights reserved.</p>
        <p className="creator-name">Created by Beduu24 / JagungRebus</p>
      </div>
    </footer>
  );
};

export default Footer;
